function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import mean from 'lodash/mean';
import round from 'lodash/round';
import cn from 'classnames';
import StackIcon from 'svg/stack.svg';
import ReadingFlagIcon from 'components/ReadingFlagIcon';
import Polygon from 'svg/polygon.svg';
import * as shapes from '../../shapes';
import messages from '../../messages';
import styles from './StackedReadingsTooltip.pcss';
var _React_PureComponent;
class StackedReadingsTooltip extends (_React_PureComponent = React.PureComponent) {
    renderTitle() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.stackedReadingsTooltip__title,
            children: [
                /*#__PURE__*/ _jsx(StackIcon, {
                    className: styles.stackedReadingsTooltip__titleIcon
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.stackedReadingsTooltip__resultText,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.seriesOfMeasurements))
                })
            ]
        });
    }
    renderReading(reading) {
        const { conversion } = this.props;
        const { displayValue, timestamp, flag, type } = reading;
        const measurementTypeClass = styles[`stackedReadingsTooltip__resultIcon--${type}`];
        const formattedDatetime = moment.unix(timestamp).utc().format('LT');
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.stackedReadingsTooltip__result,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "d-flex",
                    children: [
                        /*#__PURE__*/ _jsx(ReadingFlagIcon, {
                            className: `${styles.stackedReadingsTooltip__resultIcon} ${measurementTypeClass}`,
                            flag: flag
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.stackedReadingsTooltip__resultText,
                            children: `${displayValue} ${conversion.unitSymbol}`
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.stackedReadingsTooltip__datetime,
                    children: formattedDatetime
                })
            ]
        }, `${timestamp}-${flag}-${type}-${displayValue}`);
    }
    renderReadings() {
        const { readings } = this.props;
        return map(readings, (reading)=>this.renderReading(reading));
    }
    renderAverage() {
        const { readings, conversion } = this.props;
        const average = round(mean(map(readings, 'displayValue')), 1);
        return /*#__PURE__*/ _jsxs("div", {
            className: cn(styles.stackedReadingsTooltip__result, styles.stackedReadingsTooltip__resultText),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: `${average} ${conversion.unitSymbol}`
                }),
                /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.dailyReport.average))
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.stackedReadingsTooltip,
            children: [
                this.renderTitle(),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.stackedReadingsTooltip__separator
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.stackedReadingsTooltip__content,
                    children: [
                        this.renderReadings(),
                        this.renderAverage(),
                        /*#__PURE__*/ _jsx(Polygon, {
                            width: "17",
                            height: "12",
                            className: styles.stackedReadingsTooltip__polygon
                        })
                    ]
                })
            ]
        });
    }
}
_define_property(StackedReadingsTooltip, "propTypes", {
    // Explicit props
    readings: PropTypes.arrayOf(shapes.reading).isRequired,
    conversion: PropTypes.object.isRequired
});
export default withStyles(styles)(StackedReadingsTooltip);
